import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './logoactivitat.module.scss';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    novaFinestra?: boolean;
    className?: string;
    children: React.ReactNode;
}>;

const STATICS_HOST = 'https://statics.3cat.cat';

export default function LogoActivitat() {
    return (
        <div className={styles.wrapper}>
            <p>
                Aquí us proporcionem un logo creat especialment per als que organitzeu activitats. Només les entitats sense ànim
                de lucre podreu fer servir aquest logo. Les empreses no estan autoritzades a fer-ne cap ús.
            </p>
            <h2>Per utilitzar-lo tingueu en compte que:</h2>
            <ol>
                <li>
                    <p>
                        Abans de fer ús del logo per als vostres propis cartells, anunci de premsa o suport digital cal{' '}
                        <strong>tenir l&apos;activitat inscrita</strong>.
                    </p>
                </li>
                <li>
                    <p>
                        Abans de publicar qualsevol cartell, anuncis de premsa o suports digitals on hi aparegui el logo, és
                        imprescindible que ens feu arribar el disseny amb prou antelació a través de l&apos;adreça{' '}
                        <Enllac href='mailto:activitatsperlamarato@3cat.cat'>activitatsperlamarato@3cat.cat</Enllac> perquè us hi
                        donem el vistiplau. <strong>Sense aquesta acceptació, no el podreu publicar</strong>.
                    </p>
                </li>
            </ol>

            <div className={styles.seccioLogo}>
                <h2>Logotip &quot;Per La Marató de 3Cat&quot;</h2>
                <div className={styles.logotip}>
                    <div className={styles.imatgeLogo}>
                        <Imatge
                            src={`${STATICS_HOST}/recursos/marato/img/espai-entitats/Logo-Per-La-Marato.png`}
                            alt='logo Per la Marató'
                            width={300}
                            height={50}
                        />
                    </div>
                    <div className={styles.arxius}>
                        <Enllac
                            href={`${STATICS_HOST}/recursos/marato/img/espai-entitats/Logo-Per-La-Marato.jpg`}
                            novaFinestra={true}
                        >
                            normal (JPEG)
                        </Enllac>
                        {' | '}
                        <Enllac
                            href={`${STATICS_HOST}/recursos/marato/img/espai-entitats/Logo-Per-La-Marato.png`}
                            novaFinestra={true}
                        >
                            normal (PNG)
                        </Enllac>
                        {' | '}
                        <Enllac href={`${STATICS_HOST}/recursos/marato/img/espai-entitats/Logo-Per-La-Marato.ai`}>
                            vectorial (AI)
                        </Enllac>
                    </div>
                </div>
            </div>

            <div className={styles.seccioInstruccions}>
                <h2>Per aplicar el logo cal seguir les indicacions següents:</h2>
                <div className={styles.instruccions}>
                    <div className={styles.imatgeInstruccions}>
                        <Imatge
                            src={`${STATICS_HOST}/recursos/marato/img/espai-entitats/img-com-aplicar-logo-espaiEntitats.2020.png`}
                            alt="Instruccions logo d'activitat inscrita"
                            width={400}
                            height={452}
                        />
                    </div>
                    <div className={styles.llistaInstruccions}>
                        <ol>
                            <li>
                                <strong>
                                    Relacioneu el logo que us proporcionem amb l&apos;activitat o l&apos;entitat organitzadora
                                </strong>
                                . Per exemple: xocolatada solidària + logo ; Associació de Dones la Mimosa + logo
                            </li>
                            <li>
                                <strong>Situació del logo</strong>: El logo &quot;d&apos;activitat&quot; no hauria
                                d&apos;encapçalar cap disseny (cartell, etc.). Destaqueu primer l&apos;activitat o l&apos;entitat
                                organitzadora.
                            </li>
                            <li>
                                <strong>
                                    L&apos;organitzador de l&apos;acte (la vostra entitat) ha de figurar en lloc preferent
                                </strong>
                                . Cal fer constar clarament el nom de l&apos;entitat o el logo de l&apos;organitzador.
                            </li>
                            <li>
                                <strong>Recordeu</strong> que us pot ser útil substituir l&apos;expressió escrita &quot;La Marató
                                de 3Cat&quot; per aquest logo específic.
                            </li>
                            <li>
                                <strong>Ubicació del logo:</strong> El logo no ha d&apos;estar mai situat entre altres logotips de
                                col·laboradors ni patrocinadors. La Marató de 3Cat és beneficiària dels diners recollits en
                                l&apos;activitat.
                            </li>
                            <li>
                                <strong>Sigueu transparents:</strong> Habitualment es destina la totalitat de la recaptació a La
                                Marató de 3Cat. En el cas que es tracti d&apos;un percentatge, ho heu de fer constar clarament al
                                cartell.
                            </li>
                            <li>
                                <strong>Forma del logo:</strong> Podeu escalar el logo, però mantingueu-ne les proporcions sense
                                distorsionar-les.
                            </li>
                            <li>
                                <strong>Disseny:</strong> En una mateixa pàgina utilitzeu el logo una única vegada.
                            </li>
                        </ol>
                    </div>
                </div>
                <div className={styles.tancament}>
                    <p>
                        En cas que vulgueu utilitzar la imatge gràfica de la campanya, si us plau mantingueu-la intacte, sense
                        retocar l&apos;eslògan, el fons o els colors.
                    </p>
                    <p>Moltes gràcies per seguir les indicacions i que tingueu molt èxit en la vostra activitat!</p>
                </div>
            </div>
        </div>
    );
}
